import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useBankStore } from "../store";

export const createBank = ({ churchId, bankData }) => {
  return axios.post(`/churches/${churchId}/banks`, bankData);
};

export const useCreateBank = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeCreateBankAccountModal =
    useBankStore.getState().closeCreateBankAccountModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("banks");
      queryClient.invalidateQueries("banks-paginated");

      setNotification({
        type: "success",
        message: "Bank account created successfully!"
      });

      closeCreateBankAccountModal();
    },
    ...config,
    mutationFn: createBank
  });
};
